/** @jsx jsx */
import withComponentBase from '@uswitch/ev-components/lib/components/helpers/with-component-base'
import Buttons from '@uswitch/ev-components/lib/components/modules/collection/collection-buttons'
import CollectionCarousel from '@uswitch/ev-components/lib/components/modules/collection/collection-carousel'
import Footer from '@uswitch/ev-components/lib/components/modules/collection/collection-footer'
import Grid from '@uswitch/ev-components/lib/components/modules/collection/collection-grid'
import ImageGrid from '@uswitch/ev-components/lib/components/modules/collection/collection-image-grid'
import Logos from '@uswitch/ev-components/lib/components/modules/collection/collection-image-logo'
import Inline from '@uswitch/ev-components/lib/components/modules/collection/collection-inline'
import Sidebar from '@uswitch/ev-components/lib/components/modules/collection/collection-sidebar'
import Tabs from '@uswitch/ev-components/lib/components/modules/collection/collection-tabs'
import TwoColContent from '@uswitch/ev-components/lib/components/modules/collection/collection-twocol-content'
import FixedSizeGrid from '@uswitch/ev-components/lib/components/modules/collection/fixed-size-grid'
import { jsx } from 'theme-ui'

const layoutsWithContainer = [
  'divided-grid',
  'fixed-size',
  'image-grid',
  'two-col-content',
  'buttons',
  'carousel',
  'footer',
  'grid',
  'inline',
  'logos',
  'large-logos',
  'sidebar',
  'default'
]
const CollectionModule = (props) => {
  switch (props?.layout) {
    case 'divided-grid':
      return <Grid {...props} divided />
    case 'fixed-size':
      return <FixedSizeGrid {...props} />
    case 'image-grid':
      return <ImageGrid {...props} />
    case 'two-col-content':
      return <TwoColContent {...props} />
    case 'buttons':
      return <Buttons {...props} />
    case 'carousel':
      return <CollectionCarousel {...props} />
    case 'footer':
      return <Footer {...props} />
    case 'grid':
      return <Grid {...props} />
    case 'inline':
      return <Inline {...props} />
    case 'logos':
      return <Logos {...props} />
    case 'large-logos':
      return <Logos {...props} variant='large' />
    case 'tabs':
      return <Tabs {...props} />
    case 'sidebar':
      return <Sidebar {...props} />
    default:
      return null
  }
}

const CollectionModuleWrapper = withComponentBase(CollectionModule, ({ layout }) => ({
  withHeaderFooter: true,
  withContainer: layoutsWithContainer.includes(layout),
  withPallette: true
}))

const Wrapper = (props) => {
  return (
    <div
      sx={
        !!props?.options?.smallPadding && {
          '& > div': { pt: 0, pb: 'md' } /* header */,
          '& .palette > div': { pb: ['xxs', 'sm'] } /* accordion header */,
          '& .palette > div > div': { mb: [0, 'sm'] } /* accordion */
        }
      }
    >
      <CollectionModuleWrapper {...props} />
    </div>
  )
}

export default Wrapper
